if (!customElements.get('product-form')) {


  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      


//(1/1) Add backorder message property
  const variantId = this.form.querySelector('[name="id"]').value;
  const backorderDataEl = document.querySelector(
    `.variant-backorder-data[data-variant-id="${variantId}"]`
  );

  const backorderMessage = backorderDataEl?.dataset.backorder;

  // Remove old property input if exists
  let existingInput = this.form.querySelector('input[name="properties[Backorder Message]"]');
  if (existingInput) existingInput.remove();

  if (backorderMessage) {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[Backorder Message]';
    hiddenInput.value = backorderMessage;
    this.form.appendChild(hiddenInput);
  }
//(1/1) End of Add backorder message property









      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // console.log('111');
            // window.location = window.routes.cart_url;
            // return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');







          // document.querySelector('#CartDrawer-Checkout').addEventListener('click', function(e) {
          //   e.preventDefault(); // Prevent immediate action

          //   const checkoutButton = document.querySelector('#CartDrawer-Checkout');
          //   // checkoutButton.textContent = 'Processing...'; // Change button text to 'Processing...'
          //   checkoutButton.disabled = true; // Optionally disable the button to prevent multiple clicks
          //     document.querySelector('.checkout-spinner').classList.remove('hidden');
          //   // Delay the navigation to checkout
          //   setTimeout(() => {
          //     window.location.href = '/checkout'; // Redirect to checkout after 800ms
          //   }, 2000); // 800ms delay
          // });

document.addEventListener('DOMContentLoaded', function() {
  // Listen for the 'click' event on the entire document
  document.body.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'CartDrawer-Checkout') {
      e.preventDefault(); // Prevent immediate action

      const checkoutButton = e.target;
      checkoutButton.disabled = true; // Optionally disable the button to prevent multiple clicks
      document.querySelector('.checkout-spinner').classList.remove('hidden');
      
      // Delay the navigation to checkout
      setTimeout(() => {
        window.location.href = '/checkout'; // Redirect to checkout after 2 seconds
      }, 2000); // 2000ms delay
    }
  });
});




        });
    }



    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
